import React, { useEffect, useState } from 'react';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from '../../config/azureConfig';
import { MicrosoftSignInButton } from './MicrosoftSignInButton';

// Create MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

interface AzureAuthProviderProps {
  children?: React.ReactNode;
}

export const AzureAuthProvider: React.FC<AzureAuthProviderProps> = ({ children }) => {
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const initializeMsal = async () => {
      try {
        console.log('=== INITIALIZING MSAL ===');
        await msalInstance.initialize();
        console.log('MSAL initialized successfully');
        setIsInitialized(true);
      } catch (error) {
        console.error('MSAL initialization failed:', error);
      }
    };

    initializeMsal();
  }, []);

  if (!isInitialized) {
    return (
      <div style={{ padding: '10px', textAlign: 'center', color: '#666' }}>
        🔄 Inicializando autenticación Microsoft...
      </div>
    );
  }

  return (
    <MsalProvider instance={msalInstance}>
      {children || <MicrosoftSignInButton />}
    </MsalProvider>
  );
};